import '.ag{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.bf{z-index:20;}.ssr-plugin'
import '.ae{margin-bottom:5rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.af{align-items:stretch;}.ssr-plugin'
import { ReactNode } from 'react'
import { Property } from 'csstype'
import { styled } from 'inlines'
import { RegionViewModel } from 'functions/app/geography/view/region'
import { RegionalNavBar } from '@app/components/blocks/navbar/regional/RegionalNavBar'
import Column from '@app/components/layout/Column'
import TopNavBar from '@app/components/blocks/navbar/main/TopNavBar'
import { ResponsiveContainer } from '@app/components/layout/ResponsiveContainer'
import Footer from '@app/components/blocks/footer/Footer'
import useMediaQuery from '@app/util/useMediaQuery'
import type { RegionsMunicipalitiesFeatures } from '@schema/featureToggle'
import { RegionalHeaderScrollProvider } from '@app/pages/discover/regions/regionalPage/RegionalHeaderScrollContext'

export type RegionalPageLayoutProps = {
  region: RegionViewModel
  tab: RegionsMunicipalitiesFeatures
  children: ReactNode
  gap?: Property.Gap<(string & {}) | 0>
}

export const RegionalPageLayout = ({
  region,
  tab,
  children,
  gap = '2rem',
}: RegionalPageLayoutProps) => {
  const isMobile = useMediaQuery()

  return (
    <RegionalHeaderScrollProvider>
      <Column
        alignItems="center"
        style={{
          justifyContent: 'center',
          background: 'var(--page-bg)',
        }}
      >
        <div className="ag n bf"
        >
          <TopNavBar
            navBarStyle={{
              position: 'static',
            }}
          />
        </div>
        <RegionalNavBar region={region} tab={tab} />

        <ResponsiveContainer
          style={{
            minHeight: '100vh',
            marginBottom: '2rem',
          }}
        >
          <main className="ae d e af"
            style={{
              gap: gap,
              paddingInline: isMobile ? 0 : '1rem',
            }}
          >
            {children}
          </main>
        </ResponsiveContainer>

        <Footer />
      </Column>
    </RegionalHeaderScrollProvider>
  )
}
